import { render, staticRenderFns } from "./Base_Type6.vue?vue&type=template&id=f19c59be&scoped=true"
import script from "./Base_Type6.vue?vue&type=script&lang=js"
export * from "./Base_Type6.vue?vue&type=script&lang=js"
import style0 from "./Base_Type6.vue?vue&type=style&index=0&id=f19c59be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19c59be",
  null
  
)

export default component.exports